import {
  $GateSandtableBatchMode,
  $GateSandtableGroupMode,
  $sandTableLoaded,
  $sandTableLoadedApi,
} from '@stores/sandTableStores';
import { type STImage, type STMatrix, SandTableType } from '@types';
import { useStore } from 'effector-react';
import { useEffect } from 'react';
import { CompassWidget } from '../CompassWidget';
import { stEditorKrpPlayer } from '../STKrpPlayer';
import {
  onImageMarkerClick,
  onMarkerClickBatchMode,
  onMarkerClickGroupMode,
} from '../actions/onMarkerClick';
import { onImageMarkerMoveEnd } from '../actions/onMarkerMoveEnd';
import { onRadarRotate } from '../actions/onRadarRotate';
import { BatchAddTip } from '../components/BatchAddTip';
import { GroupCaptureWidget } from '../components/GroupCaptureWidget';
import { GroupWidget } from '../components/GroupWidget';
import ImageEditorButtons from './ImageEditorButtons';
import ImageMarkerWidgets from './ImageMarkerWidgets';

interface Props {
  data: STImage | STMatrix;
}

const PLAYER_ID = 'editor_krp';

function SandTablePlayerImage({ data }: Props) {
  const loaded = useStore($sandTableLoaded);
  let mediaUrl: string | undefined;
  let matrixId: number | undefined;
  if (data.type === SandTableType.image) {
    mediaUrl = data.mediaUrl;
  }
  if (data.type === SandTableType.matrix) {
    matrixId = data.data;
  }

  useEffect(() => {
    return () => {
      stEditorKrpPlayer.remove();
      $sandTableLoadedApi.off();
    };
  }, []);

  useEffect(() => {
    stEditorKrpPlayer.create({
      target: PLAYER_ID,
      data,
      onRadarRotate,
      onReady: $sandTableLoadedApi.on,
      onMarkerClick: handleMarkerClick,
      onMarkerMoveEnd: onImageMarkerMoveEnd,
    });
  }, [data.id, mediaUrl, matrixId]);

  const handleMarkerClick = (id: string) => {
    if ($GateSandtableGroupMode.state.getState()) {
      onMarkerClickGroupMode(id);
    } else if ($GateSandtableBatchMode.state.getState()) {
      onMarkerClickBatchMode(id);
    } else {
      onImageMarkerClick(id);
    }
  };

  return (
    <>
      <div className="absolute inset-0 " id={PLAYER_ID} />
      {loaded && (
        <>
          <ImageMarkerWidgets />
          <ImageEditorButtons />
          <BatchAddTip />
          <CompassWidget />
          <GroupCaptureWidget />
          <GroupWidget />
        </>
      )}
    </>
  );
}

export default SandTablePlayerImage;
